import { Scope, ScopeId } from '@pubstack/common/src/scope'
import { Path } from 'react-router-dom'

const SHORT_ID_LENGTH = 8
const SCOPE_SEGMENT = /^[0-9a-f]{8}(-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})?$/

export const scopeFromPath = (pathname: string): string | undefined => {
  const segment = pathname.split('/')[1]
  return segment && SCOPE_SEGMENT.test(segment) ? segment : undefined
}

export const scopeBasename = (pathname: string): string | undefined => {
  const scope = scopeFromPath(pathname)
  return scope ? `/${scope}` : undefined
}

export const shortScopeId = (scopeId: ScopeId, scopes: Scope[] = []): string => {
  const short = scopeId.slice(0, SHORT_ID_LENGTH)
  return scopes.some((scope) => scope.id !== scopeId && scope.id.startsWith(short)) ? scopeId : short
}

export const resolveScopeId = (shortId: string, scopes: Scope[]): ScopeId | undefined => {
  const matches = scopes.filter((scope) => scope.id.startsWith(shortId))
  return matches.length === 1 ? matches[0].id : undefined
}

export const scopedHref = (shortId: string, { pathname, search, hash }: Path): string => `/${shortId}${pathname === '/' ? '' : pathname}${search}${hash}`
